<template>
  <aside class="plus-sidebar">
    <div class="plus-sidebar__logo">
      <router-link to="/" class="plus-sidebar__logo-link" title="首页">
        <img
          :src="logoUrl"
          alt="Plus.ai"
          class="plus-sidebar__logo-img"
          draggable="false"
        />
      </router-link>
    </div>

    <nav class="plus-sidebar__nav">
      <button
        v-for="s in sidebarItems"
        :key="s.key"
        type="button"
        class="plus-side-btn"
        :class="{ 'plus-side-btn--active': s.key === activeSidebarKey }"
        :title="s.label"
        @mouseenter="onNavHover(s)"
        @click="onNavClick(s)"
      >
        <span class="plus-side-btn__icon-wrap" :class="s.key === 'member' ? 'plus-side-btn__icon-wrap--member' : ''">
          <i :class="[s.icon, 'plus-side-btn__icon']"></i>
        </span>
        <span class="plus-side-btn__label">{{ s.short }}</span>
      </button>
    </nav>

    <div class="plus-sidebar__footer">
      <!-- <button type="button" class="plus-side-aux-btn" title="设置">
        <i class="fas fa-cog"></i>
      </button>
      <button type="button" class="plus-side-aux-btn" title="帮助">
        <i class="fas fa-question-circle"></i>
      </button> -->
      <button type="button" class="plus-side-avatar" title="账户" @click="onUserClick">
        <i class="fas fa-user"></i>
      </button>
    </div>
  </aside>
</template>

<script>
import { requestBalanceBillingModal } from '../utils/balanceBillingGate'
import { prefetchVipPlans } from '../utils/vipPlansCache'

const PLUS_SIDEBAR_LOGO_URL =
  'https://plusyifanshang.oss-cn-hangzhou.aliyuncs.com/box/img/other/2ndgUDQ5HlwKw591eaNlqmENgjRa2x9yYMyr8kcz.png'

const SIDEBAR_ITEMS = [
  { key: 'home', icon: 'fas fa-house', label: '首页', short: '首页' },
  { key: 'create', icon: 'fas fa-wand-magic-sparkles', label: '创作', short: '创作' },
  { key: 'script', icon: 'fas fa-scroll', label: '剧本', short: '剧本' },
  { key: 'assets', icon: 'fas fa-layer-group', label: '资产', short: '资产' },
  { key: 'skills', icon: 'fas fa-bolt', label: '技能', short: '技能' },
  { key: 'digital-human', icon: 'fas fa-user-astronaut', label: '数字人', short: '数字人' },
  // { key: 'community', icon: 'fas fa-users', label: '社区', short: '社区' },
  // { key: 'tv', icon: 'fas fa-tv', label: 'PlusTV', short: 'TV' },
  { key: 'member', icon: 'fas fa-gem', label: '会员', short: '会员' }
]

export default {
  name: 'PlusAppSidebar',
  data() {
    return {
      logoUrl: PLUS_SIDEBAR_LOGO_URL,
      sidebarItems: SIDEBAR_ITEMS
    }
  },
  computed: {
    activeSidebarKey() {
      const p = this.$route.path || ''
      if (p === '/' || p === '/plus') return 'home'
      if (p === '/workspace') return 'create'
      if (p === '/script-studio' || p.startsWith('/script-studio') || p.startsWith('/script-create')) {
        return 'script'
      }
      if (p.startsWith('/assets')) return 'assets'
      if (p === '/skills' || p.startsWith('/skills')) return 'skills'
      if (p === '/digital-human' || p.startsWith('/digital-human')) return 'digital-human'
      if (p === '/pricing' || p.startsWith('/pricing')) return 'member'
      return ''
    }
  },
  mounted() {
    prefetchVipPlans().catch(() => {})
  },
  methods: {
    prefetchPricingPlans() {
      prefetchVipPlans().catch(() => {})
    },
    onNavHover(s) {
      if (s.key === 'member') this.prefetchPricingPlans()
    },
    onUserClick() {
      requestBalanceBillingModal()
    },
    onNavClick(s) {
      if (s.key === 'home') {
        this.$router.push('/').catch(() => {})
        return
      }
      if (s.key === 'create') {
        this.$router.push('/workspace').catch(() => {})
        return
      }
      if (s.key === 'script') {
        this.$router.push('/script-studio').catch(() => {})
        return
      }
      if (s.key === 'assets') {
        this.$router.push('/assets').catch(() => {})
        return
      }
      if (s.key === 'skills') {
        this.$router.push('/skills').catch(() => {})
        return
      }
      if (s.key === 'digital-human') {
        this.$router.push('/digital-human').catch(() => {})
        return
      }
      if (s.key === 'member') {
        this.$router.push('/pricing').catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.plus-sidebar {
  position: relative;
  z-index: 50;
  display: flex;
  width: 100%;
  flex-shrink: 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0) 18%),
    linear-gradient(180deg, rgba(12, 12, 14, 0.92) 0%, rgba(6, 6, 8, 0.96) 100%);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.plus-sidebar__logo {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.plus-sidebar__logo-link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 12px;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease;
}

.plus-sidebar__logo-link:hover {
  background: rgba(255, 255, 255, 0.06);
}

.plus-sidebar__logo-img {
  height: 28px;
  width: auto;
  max-width: 5.5rem;
  object-fit: contain;
  object-position: center;
}

.plus-sidebar__nav {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}

.plus-sidebar__nav::-webkit-scrollbar {
  display: none;
}

.plus-side-btn {
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 52px;
  padding: 6px 8px;
  border: 1px solid transparent;
  border-radius: 14px;
  background: transparent;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.18s ease,
    box-shadow 0.2s ease;
}

.plus-side-btn__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 11px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(255, 255, 255, 0.03);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.18s ease;
}

.plus-side-btn__icon-wrap--member {
  background: linear-gradient(145deg, rgba(251, 191, 36, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
}

.plus-side-btn__icon {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.42);
  transition: color 0.2s ease, filter 0.2s ease;
}

.plus-side-btn__label {
  max-width: 3.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.38);
  transition: color 0.2s ease;
}

.plus-side-btn:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.06);
}

.plus-side-btn:hover .plus-side-btn__icon-wrap {
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  transform: translateY(-1px);
}

.plus-side-btn:hover .plus-side-btn__icon {
  color: rgba(255, 255, 255, 0.82);
}

.plus-side-btn:hover .plus-side-btn__label {
  color: rgba(255, 255, 255, 0.72);
}

.plus-side-btn--active {
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.14) 0%, rgba(99, 102, 241, 0.06) 100%);
  border-color: rgba(129, 140, 248, 0.22);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 8px 24px -14px rgba(79, 70, 229, 0.45);
}

.plus-side-btn--active::before {
  content: '';
  position: absolute;
  bottom: 4px;
  left: 50%;
  width: 14px;
  height: 2px;
  border-radius: 999px;
  transform: translateX(-50%);
  background: linear-gradient(90deg, #818cf8, #22d3ee);
  box-shadow: 0 0 8px rgba(129, 140, 248, 0.65);
}

.plus-side-btn--active .plus-side-btn__icon-wrap {
  border-color: rgba(165, 180, 252, 0.28);
  background: linear-gradient(145deg, rgba(129, 140, 248, 0.22) 0%, rgba(56, 189, 248, 0.08) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.12),
    0 0 16px rgba(99, 102, 241, 0.18);
}

.plus-side-btn--active .plus-side-btn__icon {
  color: #fff;
  filter: drop-shadow(0 0 6px rgba(165, 180, 252, 0.45));
}

.plus-side-btn--active .plus-side-btn__label {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}

.plus-sidebar__footer {
  display: flex;
  align-items: center;
  gap: 4px;
}

.plus-side-aux-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.42);
  font-size: 13px;
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease;
}

.plus-side-aux-btn:hover {
  border-color: rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.88);
}

.plus-side-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.04) 100%);
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px;
  cursor: pointer;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 4px 14px -6px rgba(0, 0, 0, 0.45);
  transition:
    border-color 0.18s ease,
    background 0.18s ease,
    transform 0.18s ease;
}

.plus-side-avatar:hover {
  border-color: rgba(165, 180, 252, 0.35);
  background: linear-gradient(145deg, rgba(129, 140, 248, 0.22) 0%, rgba(255, 255, 255, 0.06) 100%);
  transform: translateY(-1px);
}

@media (min-width: 768px) {
  .plus-sidebar {
    width: 4.5rem;
    min-height: 100vh;
    min-height: 100dvh;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0;
    padding: 18px 0 16px;
    border-bottom: none;
    border-right: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.02);
  }

  .plus-sidebar::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(129, 140, 248, 0.18) 0%,
      rgba(255, 255, 255, 0.04) 28%,
      rgba(255, 255, 255, 0.02) 72%,
      rgba(34, 211, 238, 0.12) 100%
    );
    pointer-events: none;
  }

  .plus-sidebar__logo {
    padding: 0 0 10px;
  }

  .plus-sidebar__logo-img {
    height: 36px;
    max-width: 3.25rem;
  }

  .plus-sidebar__nav {
    flex: 1;
    flex-direction: column;
    gap: 4px;
    overflow: visible;
    padding: 8px 0;
    width: 100%;
  }

  .plus-side-btn {
    width: calc(100% - 12px);
    min-width: 0;
    padding: 8px 0;
    margin: 0 6px;
    border-radius: 16px;
  }

  .plus-side-btn__label {
    display: inline;
  }

  .plus-side-btn--active::before {
    top: 50%;
    bottom: auto;
    left: -6px;
    width: 3px;
    height: 22px;
    border-radius: 0 3px 3px 0;
    transform: translateY(-50%);
  }

  .plus-sidebar__footer {
    flex-direction: column;
    gap: 8px;
    padding-top: 12px;
    margin-top: auto;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    width: calc(100% - 16px);
    padding-left: 8px;
    padding-right: 8px;
  }
}

@media (max-width: 639px) {
  .plus-side-btn__label {
    display: none;
  }

  .plus-side-btn {
    min-width: 44px;
    padding: 6px;
  }
}

@media (min-width: 640px) and (max-width: 767px) {
  .plus-side-btn__label {
    display: inline;
  }
}
</style>
